import styled from 'styled-components';

export const MainHeadStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .logo-wrapper {
    display: flex;
    gap: 16px;
    align-items: center;
    & .plans {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
  }

  .head-data {
    display: flex;
    flex-direction: column;

    & .head-data-main {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    & .head-data-due {
      display: flex;
      gap: 5px;
      flex-direction: column;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      flex-direction: row;
      justify-content: space-between;
    }
  }
`;
